module.exports = __webpack_public_path__ + "static/img/case_tab_13.eb74d63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_tab_13.png
// module id = K+EW
// module chunks = 34